<template >
    <div class="garyaBg montserrat overflow-hidden">
        <section class="w-full  flexmobile2 text-white md:h-full background-next">
    <div class="container md:mx-auto  md:py-44 lg:py-24">
      <div class=" flexmobile2  lg:flex-row items-center ">
        <div class="lg:w-1/2 mb-8 lg:mb-0">
          <h1 class="text-3xl sm:text-md md:text-4xl lg:text-5xl font-bold mb-6">
            NextHome
                  </h1>
          <h2 class="text-2xl md:text-3xl lg:text-4xl font-medium">
            Responsive Travel Application    </h2>
        </div>
        <div class="lg:w-full flex justify-center animate__animated animate__zoomInRight">
          <img
          loading="lazy"
            src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670437/next_2_whbokn.png"
            alt="Eater Chicago website mockup"
            class="w-full  mx-auto"
          />
        </div>
      </div>
    </div>
  </section>
  <!-- end of first hero section -->
  <div class="flex mx-auto  flexmobile2 flex-col pt-2.5">
    <main class="flex flexmobile2 flex-col items-start px-4 md:px-20   w-full">
      
        <!-- section two -->
      <section class="md:w-full mx-auto container md:mt-10">
        <div class="flex flexmobile2 flex-col md:flex-row justify-between">
          <div class="w-full md:w-9/12">
            <h1 class="self-start text-4xl font-semibold text-white">My Role</h1>

            <section class="travel-app-description mt-5">
                
      
    <h2 class=" text-white max-w-[868px] pt-6">
      <span class="text-sky-200">Led</span> a team of 4 in <span class="text-sky-200">conceptualizing</span> a responsive travel app for unfamiliar destinations
    </h2>
    <ul class=" text-white max-w-[868px] list-none">
      <li class="pt-6 text-lg ">Conducted desk research and <span class="text-sky-200">analyzed target audience</span></li>
      <li class="pt-6 text-lg ">Did <span class="text-sky-200">Storyboarding</span> to gain a clearer understand of user frustrations and expectations</li>
      <li class="pt-6 text-lg "><span class="text-sky-200">Designed functional prototypes</span> for mobile and desktop users</li>
    </ul>
  </section>
          </div>
          <div class="mobile-hidden">
            <img loading="lazy" class="" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670445/nextline_omtelj.png" alt="">
          </div>
          <aside class="flex flexmobile2 flex-col ml-0 md:ml-8 w-full md:w-3/12 mt-10 md:mt-0">
            <div class="flex flex-col items-start text-3xl md:text-4xl text-white">
              <h1 class="self-start text-4xl font-semibold text-white">Duration</h1>
              <p class=" pt-6 text-lg text-white">8 weeks</p>
              <h1 class="self-start text-4xl font-semibold text-white pt-6 md:pt-16">Group of 4</h1>
              <h1 class="self-start text-4xl font-semibold text-white pt-6 md:pt-16">Tools</h1>
              <p class="pt-6 text-lg  text-white">
                Figma, Axure RP, Microsoft Bling</p>
            </div>
          </aside>
        </div>
      </section>
      <!-- end of section two -->
    </main>
  </div>
  <!-- Add responsiveness to other sections similarly -->
          <div>
          <main>
          <!-- section four -->
          <section class="mt-72  px-10 background-next2 h-[350px]  max-md:mt-10 ">
            <div class="p-10 flexmobile flex justify-between items-center text-center">
             <div>
                <p class="text-white text-xl md:text-2xl">Simple & Intuitive Interface</p>
                    <p class="text-white pt-6 text-3xl md:text-5xl font-bold">100%</p>
             </div>
             <div>
                <p class="text-white text-xl md:text-2xl">User Satisfaction Score</p>
                    <p class="text-white pt-6 text-3xl md:text-5xl font-bold">4.85</p>
            </div>
            <div>
                <p class="text-white text-xl md:text-2xl">Task Success Rate  </p>
                    <p class="text-white pt-6 text-3xl md:text-5xl font-bold">93%</p>
            </div>
            </div>
            </section>
            <!-- end of four -->
            </main>
            </div>
            <main class=" flexmobile mx-auto px-20">
            <!-- five section  -->
            <section class="w-full mt-20 m md:mt-44">
        <div class="">
        <div class="w-full ">
        <section class=" rounded-none ">
        <h1 class="self-start text-4xl font-semibold text-white">Desk Research </h1>
        <p class=" pt-6 text-lg md:pt-16 text-white ">According to UN Migration 2022 report, the current global estimate is 281 million international migrants in the world, which equates to 3.6 % of the global population.</p>
        <section class=" rounded-none p-10 ">
        <h1 class="text-2xl md:text-3xl font-semibold pt-6 text-sky-200">Identifying Target Demographic</h1>
        <p class=" pt-6 text-lg md:pt-12 text-white ">    According to <span class="text-sky-200">Bookings Metro 2022 report</span>, the highest migration rates occur among <span class="text-sky-200">young adults</span> ages <span class="text-sky-200">20 to 34</span> and children under age 10 (the latter group largely reflecting children of the former).
        </p>
        </section>
        <div class="flex justify-center mt-8">
            <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670672/screen10_yugxky.png" alt="">
        </div>
    </section>
    <section class="flex mt-10 flex-col items-start text-xl  text-white rounded-none">
    <article class="z-10 mt-0 max-md:max-w-full"> 
      <p class=" pt-6 text-lg " >
        Young adults move most frequently and for a variety of reasons like:<br /><br />
        <ol class=" list-disc ml-8">
  <li class="pt-6 text-lg ">Warmer climate</li>
  <li class="pt-6 text-lg ">Political environments</li>
  <li class="pt-6 text-lg ">Being closer to family</li>
  <li class="pt-6 text-lg ">Finding more affordable housing</li>
  <li class="pt-6 text-lg ">Higher studies</li>
  <li class="pt-6 text-lg ">Career demands</li>
  <li class="pt-6 text-lg ">Lifestyle experiences</li>
</ol>

      </p>
    </article>
    <article class="pt-6 text-lg  max-md:max-w-full">
      <h2 class="sr-only">Technology Usage Among Young Adults</h2>
      <p class="pt-6 text-lg md:pt-16">
        This user group is <span class="text-sky-200">well versed</span> with latest advancements in <span class="text-sky-200">technology</span> and fluent with its usage.<br /><br />
        Therefore, developing a responsive application is an optimal choice as it can help provide a fluent user experience for both mobile and desktop users.
      </p>
    </article>
  </section>
        </div>
        </div>
            </section>
            </main>
            <!-- section sex -->
            <section class="flex items-center justify-between flexmobile  mt-44 px-20 mx-auto flex-col rounded-none">
  <section class="max-w-[989px]">
    <div class="flex gap-5 max-md:flex-col">
      <div class="flex flex-col w-[32%] max-md:ml-0 max-md:w-full">
        <img 
          loading="lazy" 
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/3800d5f216cd37f30e6dec8d6656e29ebe3d5e11efecec7c0498fb23f2bf1d41?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" 
          alt="Visual representation of identified painpoints" 
          class="object-contain grow w-full aspect-[0.54] max-md:mt-10 painpoints-image" 
        />
      </div>
      <div class="flex flex-col container mx-auto w-[68%] max-md:ml-0 max-md:w-full ml-80">
        <div class="flex z-10 flex-col self-stretch my-auto mr-0 max-md:mt-10 max-md:max-w-full">
          <h1 class="font-semibold pt-10 md:pt-20 text-2xl md:text-4xl text-white "> Identified Painpoints</h1>
          <ul class="text-white max-md:max-w-full list-none">
            <li class="pt-6 text-lg md:pt-16">Cannot find all the information in one place</li>
            <li class="pt-6 text-lg ">Difficulty to find local Information</li>
            <li class="pt-6 text-lg ">Lack personalization and filtering options</li>
            <li class="pt-6 text-lg ">Accessibility issues in multimedia devices</li>
            <li class="pt-6 text-lg ">Adaption issues due to cultural shift and language barriers</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</section>

            <!-- section user -->
             <section class="  mx-auto px-20 mt-32 text-white">
                <h1 class="font-semibold pt-10 md:pt-20 text-2xl md:text-4xl text-white ">User Personas & Empathy Maps</h1>
             </section>
            <!-- section seven -->
            <section class=" flexmobile2 mt-32 md:mt-56 mx-auto px-20">
  <section class="flex gap-5 max-md:flex-col">
    <section class="flex flex-col w-[30%] max-md:ml-0 max-md:w-full">
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670850/lucy2_vcpnmt.png" class="object-contain grow w-full aspect-[0.45] max-md:mt-10 max-md:max-w-full" />
    </section>
    <section class="flex flex-col mx-auto w-[70%] max-md:ml-0 max-md:w-full">
      <div class="flex z-10 flex-col self-stretch my-auto w-full max-md:mt-10 max-md:-mr-2.5 max-md:max-w-full">
        <h1 class="self-center text-6xl font-semibold text-sky-200 max-md:max-w-full max-md:text-4xl">
         Lucy Hayland, 23
        </h1>
        <p class="self-center mt-5 text-3xl font-medium text-center text-amber-50 w-[550px]  max-md:max-w-full">
          Moved from Mexico to London, UK
        </p>
        <blockquote class="self-start dancing-script mt-24  text-3xl font-semibold text-sky-200 max-md:mt-10 max-md:max-w-full">
          "I want to survive and explore on a budget while also connecting with people from my homeland"
        </blockquote>
        <div class=" ">
        </div>
        <div class="mt-9 flex flex-wrap gap-5 justify-between max-md:max-w-full">
          <div class="flex md:ml-0  p flexmobile2 gap-5 max-md:flex-col">
            <div class="w-full">
              <h2 class="mt-20 text-2xl font-bold text-sky-200">PAIN POINTS</h2>
              <ol class="list-disc text-lg font-medium text-amber-50 max-md:max-w-ful">
                <li class=" mt-4 text-amber-50 w-full">Budget constraints</li>
                <li class=" mt-4 text-amber-50 w-full">Cultural isolation due to language barriers</li>
                <li class=" mt-4 text-amber-50 w-full">Loneliness</li>
                <li class=" mt-4 text-amber-50 w-full">Homesickness</li>
              </ol>
            </div>
            <div class="w-full">
              <h2 class="mt-20 text-2xl font-bold text-sky-200">GOALS</h2>
              <ol class="list-disc text-lg font-medium text-amber-50 max-md:max-w-ful">
                <li class=" mt-4 text-amber-50 w-full">Explore on a budget</li>
                <li class=" mt-4 text-amber-50 w-full">Effectively communicate with locals to blend in</li>
                <li class=" mt-4 text-amber-50 w-full">Connect with like-minded individuals</li>
                <li class=" mt-4 text-amber-50 w-full">Find authentic Mexican eateries</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
            </section>
            <!-- section eight -->
            <section class=" mt-32 mx-auto px-20 flexmobile2">
  <section class="rounded-none">
    <div class="flex gap-5 max-md:flex-col dancing-script">
      <!-- Left Section -->
      <div class="flex flex-col w-[41%] max-md:w-full -ml-12">
        <div class="flex flex-col items-center text-xl font-semibold text-amber-50 max-md:mt-10">
          <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670937/Group_1_4_gyefti.png" alt="">
          <p class="mt-2 text-center text-3xl">I wish to connect with likeminded people</p>
          <p class="mt-9 mb-4 text-center text-3xl">
            I wish that I could find authentic Mexican restaurants because I miss the food from my hometown
          </p>
          <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670954/Group_1_2_ohxseh.png" alt="" class="mt-8">
          <p class="mt-2 text-3xl">Full-time International graduate student</p>
          <p class="mt-8 text-3xl">Works part-time for 4 days a week</p>
        </div>
      </div>

      <!-- Middle Section with Image -->
      <div class="flex flex-col mx-auto container w-[24%] max-md:w-full max-md:ml-0">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670859/lucy1_i8quw8.png" alt="Persona image" class="object-contain self-stretch my-auto w-[343px] max-md:mt-10 aspect-[0.97]" />
      </div>

      <!-- Right Section -->
      <div class="flex flex-col mx-auto container w-[35%] max-md:w-full max-md:ml-0">
        <div class="flex z-10 flex-col items-center text-xl font-semibold text-amber-50 max-md:mt-10">
          <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671004/Group_1_3_szwfcq.png" alt="">
          <p class="mt-2 text-center text-3xl">
            I want to survive and explore on a budget
          </p>
          <p class="mt-8 text-center text-3xl">
            I want to converse with the local people fluently
          </p>
          <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671028/Group_1_1_ebhhf6.png" alt="" class="mt-24">
          <p class="mt-2 text-3xl">Homesick</p>
          <p class="mt-8 text-3xl">Lonely at times</p>
        </div>
      </div>
    </div>
  </section>
            </section>
            <!-- section nine -->
            <section class=" flexmobile2 mt-32 md:mt-96 mx-auto px-20">
  <section class="flex gap-5 max-md:flex-col">
    <section class="flex flex-col ml-5 w-[70%] max-md:ml-0 max-md:w-full">
      <div class="flex z-10 flex-col self-stretch my-auto w-full max-md:mt-10 max-md:-mr-2.5 max-md:max-w-full">
        <h1 class="self-center text-6xl font-semibold text-sky-200 max-md:max-w-full max-md:text-4xl">
            Meera Bhatia, 26
        </h1>
        <p class="self-center mt-5 text-3xl font-medium text-center text-amber-50 w-[550px]  max-md:max-w-full">
            Moved from India to Chicago, US
        </p>
        <blockquote class="self-start dancing-script mt-24  text-3xl font-semibold text-sky-200 max-md:mt-10 max-md:max-w-full">
            "I love a good party and try new experiences. I want to explore the local culture make new friends."        </blockquote>
        <div class=" ">
        </div>
        <div class="mt-9 flex flex-wrap gap-5 justify-between max-md:max-w-full">
          <div class="flex md:ml-0  p flexmobile2 gap-5 max-md:flex-col">
            <div class="w-full">
              <h2 class="mt-20 text-2xl font-bold text-sky-200">PAIN POINTS</h2>
              <ol class="list-disc text-lg font-medium text-amber-50 max-md:max-w-ful">
                <li class=" mt-4 text-amber-50 w-full">Difficulty connecting with people</li>
                <li class=" mt-4 text-amber-50 w-full">Unaware of local rules and language</li>
                <li class=" mt-4 text-amber-50 w-full">Difficulty in navigating around the city</li>
                <li class="mt-4 text-amber-50 w-full">Unaware of local hangout spots</li>
              </ol>
            </div>
            <div class="w-full">
              <h2 class="mt-20 text-2xl font-bold text-sky-200">GOALS</h2>
              <ol class="list-disc text-lg font-medium text-amber-50 max-md:max-w-ful">
                <li class=" mt-4 text-amber-50 w-full">Network with people</li>
                <li class=" mt-4 text-amber-50 w-full">Learn about local culture</li>
                <li class=" mt-4 text-amber-50 w-full">Get accustomed to local public transport</li>
                <li class=" mt-4 text-amber-50 w-full">Find a central hub for reliable travel information</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="flex flex-col w-[30%] max-md:ml-0 max-md:w-full">
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671132/Subject_66_yaw8ou.png" class="object-contain grow w-full aspect-[0.45] max-md:mt-10 max-md:max-w-full" />
    </section>
  </section>
            </section>
            <!-- section ten -->
            <section class=" mt-32 mx-auto px-20 flexmobile2">
  <section class="rounded-none">
    <div class="flex gap-5 max-md:flex-col dancing-script">
      <!-- Left Section -->
      <div class="flex flex-col w-[41%] max-md:w-full">
        <div class="flex flex-col items-center text-xl font-semibold text-amber-50 max-md:mt-10">
          <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670937/Group_1_4_gyefti.png" alt="">
          <p class="mt-8 text-center text-3xl">I want to make new friends and network</p>
          <p class="mt-9 text-center text-3xl">
            I want to explore the local scene; food & culture as well as tour the city          </p>
          <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726670954/Group_1_2_ohxseh.png" alt="" class="mt-20">
          <p class="mt-9 text-3xl">Senior Software Engineer at Amazon</p>
          <p class="mt-8 text-3xl">Strictly balances work and personal life</p>
        </div>
      </div>

      <!-- Middle Section with Image -->
      <div class="flex flex-col ml-5 w-[24%] max-md:w-full max-md:ml-0">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671121/Subject_68_iihyia.png" alt="Persona image" class="object-contain self-stretch my-auto w-[343px] max-md:mt-10 aspect-[0.97]" />
      </div>

      <!-- Right Section -->
      <div class="flex flex-col ml-5 w-[35%] max-md:w-full max-md:ml-0">
        <div class="flex z-10 flex-col items-center text-xl font-semibold text-amber-50 max-md:mt-10">
          <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671004/Group_1_3_szwfcq.png" alt="">
          <p class="mt-9 text-center text-3xl">
            I want to make the most of my time in this new city
          </p>
          <p class="mt-8 text-center text-3xl">
            I love a good time and don’t mind spending a little extra for it          </p>
          <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726671028/Group_1_1_ebhhf6.png" alt="" class="mt-12">
          <p class="mt-8 text-3xl text-center">Excited to try new experiences but doesn’t know how</p>
          <p class="mt-8 text-3xl">Wanderlust but Confused</p>
        </div>
      </div>
    </div>
  </section>
            </section>
 <NextProjectTwo/>
 <NextProjectThree/>
</div>

        </template>

<script>
import NextProjectTwo from './NextProjectTwo.vue';
import NextProjectThree from './NextProjectThree.vue';

export default {
  name: 'NextProject',
  components: {
    NextProjectTwo,
    NextProjectThree,
  },
  mounted() {
    const painpointsImage = this.$el.querySelector('.painpoints-image');

    // Create an Intersection Observer to detect when the image enters the viewport
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Add the animation class when the image is in view
          painpointsImage.classList.add('animate__animated', 'animate__fadeInDown');
        }
      });
    });

    // Observe the image
    observer.observe(painpointsImage);
  },
};
</script>

<style>
.background-next{
  background: linear-gradient(180deg, rgba(68, 101, 152, 0.90) 6.82%, rgba(42, 58, 83, 0.70) 47.7%, rgba(28, 36, 49, 0.80) 71.56%, rgba(22, 25, 31, 0.70) 83.48%, #0F0E0E 95.41%);
}
.background-next2{
  background: linear-gradient(180deg, #446598 6.82%, rgba(42, 58, 83, 0.70) 35.8%, rgba(28, 36, 49, 0.80) 54.12%, rgba(22, 25, 31, 0.70) 67.44%, #0F0E0E 95.41%);
}
.Bakery-Linear{
    background: linear-gradient(90deg, rgba(248,146,146,1) 0%, rgba(137,2,35,1) 35%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@media (max-width:740px){
    .flexmobile2{
        display: block;
        margin-left: 0;
        padding: 10px;
        gap: 0 !important;
        font-size: 20px;
    }
    
    .max-w-small-mobile{
        max-width: 100%;
        width: 100%;
    }
}

</style>
